<template>
  <section v-if="passengers.length">
    <div class="max-w-screen-2xl mx-auto px-4 flex flex-wrap py-10 my-6">
      <div class="w-full pt-10">
        <h2 class="font-secondary text-2xl md:text-3xl mb-8">
          {{ tr('Group Travelers') }}
        </h2>
      </div>

      <div class="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-6">
        <div
          v-for="(pax, index) in passengers"
          :key="index"
          class="passenger-box border-5 border-dark shadow-2xl p-6 flex flex-col items-center text-center rounded-xl"
        >
          <svg width="70" height="16" viewBox="0 0 70 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M50.5875 0L69.1588 10.8708L66.3134 15.9716L50.4742 6.70003L34.9642 15.0621L19.4218 6.6825L2.74625 16L0 10.8425L19.3734 0.0175261L34.9642 8.42325L50.5875 0Z" fill="#F19F00"/>
          </svg>
          <p class="font-secondary text-xl mt-4 mb-1">{{ displayName(pax.name) }}</p>
          <p class="uppercase text-xs text-dark-gray mb-4" v-if="pax.paxCount">
            {{ pax.paxCount }} {{ tr(pax.paxCount === 1 ? 'Traveler' : 'Travelers') }}
          </p>
          <a
            class="font-light border border-dark bg-white text-md py-2 px-4 w-full hover:bg-primary hover:text-dark transition-all hover:border-primary rounded-lg text-center cursor-pointer"
            @click="viewItinerary(pax.name)"
          >{{ tr('View Itinerary') }}</a>
          <a
            class="font-light border border-dark bg-white text-md py-2 px-4 mt-3 w-full hover:bg-primary hover:text-dark transition-all hover:border-primary rounded-lg text-center cursor-pointer"
            @click="viewHotels(pax.name)"
          >{{ tr('View') }} {{ tr('Hotels') }}</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'GroupTravelers',
  computed: {
    passengers() {
      return (this.$store.state.groupPrices || [])
        .map((price) => ({
          name: price.PaxName,
          paxCount: price.PaxCount,
        }));
    },
  },
  methods: {
    displayName(name) {
      return (name || '').trim().toUpperCase() === 'PRINCIPAL'
        ? this.tr('PRINCIPAL')
        : name;
    },
    viewItinerary(name) {
      const route = this.$router.resolve({
        name: 'GroupItinerary',
        params: { name },
        query: this.$route.query,
      });
      window.open(route.href, '_blank');
    },
    viewHotels(name) {
      const route = this.$router.resolve({
        name: 'GroupHotels',
        params: { name },
        query: this.$route.query,
      });
      window.open(route.href, '_blank');
    },
    tr(key) {
      return this.$root.tr(key);
    },
  },
};
</script>
